export const NotificationGlobalConfig = {
  DURATION: 8500,
  POSITION: 'bottom-left',
  TYPE_SUCCESS: 'success',
  TYPE_WARNING: 'warning',
  TYPE_ERROR: 'error',
  OFFSET: 0
}



//////////////////
// WEBPACK FOOTER
// ./config/Notification_config.js
// module id = Hodp
// module chunks = 3